import { render, staticRenderFns } from "./OrderItemAttachmentLinkCreateModal.vue?vue&type=template&id=2eb4ffef"
import script from "./OrderItemAttachmentLinkCreateModal.vue?vue&type=script&lang=js"
export * from "./OrderItemAttachmentLinkCreateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports